<template>
	<div>
		<el-dialog
			:title="`${scene === 'add' ? '添加' : '修改'}配置`"
			width="700px"
			v-model="data.visible"
			@close="handleCancle"
		>
			<el-form label-width="90px">

				<el-form-item label="充值金额">
					<el-input
						type="number"
						v-model="data.formLabelAlign.rechargeAmount"
						placeholder="请输入充值金额"
					></el-input>
				</el-form-item>
				<el-form-item label="赠送金额">
					<el-input
						type="number"
						v-model="data.formLabelAlign.giftAmount"
						placeholder="请输入赠送金额"
					></el-input>
				</el-form-item>
			</el-form>
			<footer class="tac" style="margin-top: 50px">
				<el-button @click="handleCancle">取消</el-button>
				<el-button type="primary" @click="handleSave">确定</el-button>
			</footer>
		</el-dialog>
	</div>
</template>

<script>
import { inject, onMounted, reactive } from "vue";
import { rechargeConfigInstal } from "@/api/requestApis.js";
export default {
	props: {
		toggle: {
			type: Boolean,
			default: false,
		},
		scene: {
			type: String,
			default: "add",
		},
		currentData: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props, context) {
		const handleSearch = inject("handleSearch");
		const data = reactive({
			visible: true,
			timeVal: "",
			formLabelAlign: {
				startHour: "",
				endHour: "",
				fee: "",
				mpvFee: "",
				rewardAmount: "",
				suvFee: "",
			},
		});
		const handleCancle = () => {
			context.emit("update:toggle", false);
		};
		const handleSave = async () => {
			await rechargeConfigInstal(
				{
					feeId:
						props.scene === "edit" ? props.currentData.feeId : null,
					...data.formLabelAlign,
				},
				props.scene === "add" ? "insert" : "update"
			);
			handleSearch();
			handleCancle();
		};
		const handleTimeChange = (val) => {
			if (val) {
				data.formLabelAlign.startHour = val[0];
				data.formLabelAlign.endHour = val[1];
			} else {
				data.formLabelAlign.startHour = "";
				data.formLabelAlign.endHour = "";
			}
		};
		onMounted(() => {
			if (props.scene === "edit") {
				data.timeVal = [
					props.currentData.startHour + ":00",
					props.currentData.endHour + ":00",
				];
				data.formLabelAlign.startHour = props.currentData.startHour;
				data.formLabelAlign.endHour = props.currentData.endHour;
				data.formLabelAlign.fee = props.currentData.fee;
				data.formLabelAlign.mpvFee = props.currentData.mpvFee;
				data.formLabelAlign.rewardAmount =
					props.currentData.rewardAmount;
				data.formLabelAlign.suvFee = props.currentData.suvFee;
			}
		});
		return {
			handleTimeChange,
			handleCancle,
			handleSave,
			data,
		};
	},
};
</script>

<style scoped>
</style>
